import { CompanySignup } from '../core/company-signup';
import { DOM } from '../core/dom';
import { FreelancerSignup } from '../core/freelancer-signup';

export namespace HomeRelated {
  export function onload(): void {
    DOM.onIdClick('home-related-find-work', FreelancerSignup.display);
    DOM.onIdClick('home-related-find-talent', CompanySignup.display);
  }
}